/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

module.exports = require("./lib/_stream_duplex.js")




/*****************
 ** WEBPACK FOOTER
 ** ./~/stream-browserify/~/readable-stream/duplex.js
 ** module id = 1720
 ** module chunks = 0
 **/